import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Menu,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Tooltip,
  CircularProgress
} from "@material-ui/core";

export default class DownloadMenu extends React.Component {
  static propTypes = {
    actions: PropTypes.shape({
      rawHeadersOnChange: PropTypes.func.isRequired
    }).isRequired,
    recordCount: PropTypes.number.isRequired,
    isFetchingFile: PropTypes.bool.isRequired,
    isFetchingRecordCount: PropTypes.bool.isRequired,
    downloadRawHeaders: PropTypes.bool.isRequired,
    downloadModalSetVisible: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      open: false
    };
  }

  handleTouchTap = event => {
    // This prevents ghost click.
    event.preventDefault();

    this.setState({
      open: true,
      anchorEl: event.currentTarget
    });
  };

  handleRequestClose = () => {
    this.setState({
      open: false
    });
  };

  // style={{ position: "absolute", top: "-4px" }}
  render() {
    const { props } = this;
    return (
      <span>
        <Button
          variant="contained"
          disabled={
            !props.recordCount ||
            props.isFetchingRecordCount ||
            props.isFetchingFile
          }
          color="primary"
          style={{
            color: "#fff"
          }}
          onClick={this.handleTouchTap}
        >
          {props.isFetchingFile ? (
            <CircularProgress size={23} style={{ verticalAlign: "middle" }} />
          ) : (
            <span>Download {props.recordCount || 0} records </span>
          )}
        </Button>

        <Menu
          anchorEl={this.state.anchorEl}
          autoWidth
          open={this.state.open}
          onClose={this.handleRequestClose}
        >
          <MenuItem>
            <Tooltip title="Get code-friendly column headers">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={props.downloadRawHeaders}
                    color="secondary"
                    onChange={() => {
                      props.actions.rawHeadersOnChange();
                    }}
                  />
                }
                label="Raw Headers"
              />
            </Tooltip>
          </MenuItem>
          <hr />
          <MenuItem
            onClick={() => {
              this.handleRequestClose();
              props.downloadModalSetVisible(true, "xlsx");
            }}
          >
            Download as Excel
          </MenuItem>
          <MenuItem
            onClick={() => {
              this.handleRequestClose();
              props.downloadModalSetVisible(true, "csv");
            }}
          >
            Download as CSV
          </MenuItem>
        </Menu>
      </span>
    );
  }
}
